module.exports = __webpack_public_path__ + "img/ceramic-excited.5add77f7.jpg";